import './Checkbox.scss';
import type { CheckboxCallbacks, CheckboxProps, ModeType } from './types';

export const Checkbox = (props: CheckboxProps, callbacks: CheckboxCallbacks) => {

    let root = document.createElement('div') as HTMLDivElement;
    root.classList.add('checkbox-eye');
    root.classList.add(props.mode);

    if (props.label === '') {
        root.style.marginRight = '0';
        root.innerHTML = `
        <div class="checkbox-eye-icon"></div>
        `;
    } else {
        root.innerHTML = `
            <div class="checkbox-eye-icon"></div>
            <span class="checkbox-eye-label">${props.label}</span>
        `;
    }

    const setChecked = (checked: boolean) => {
        props.checked = checked;
        let icon_element = root.querySelector('.checkbox-eye-icon') as HTMLElement;
        if (icon_element) {
            icon_element?.classList.remove('icon-unchecked');
            icon_element?.classList.remove('icon-checked');
            if (checked) {
                icon_element?.classList.add('icon-checked');
            } else {
                icon_element?.classList.add('icon-unchecked');
            }
        } else {
            throw new Error('Element with .checkbox-eye-icon class not found in Checkbox');
        }
    }

    const setEnabled = (enabled: boolean) => {
        props.disabled = !enabled;
        if (enabled) {
            root.classList.remove('disabled');
            root.style.opacity = '1';
        } else {
            root.classList.add('disabled');
            root.style.opacity = '0.5';
        }
    }

    const setLabel = (label: string) => {
        props.label = label;
        let label_element = root.querySelector('.checkbox-eye-label') as HTMLElement;
        if (label_element) {
            label_element.innerHTML = label;
        }
    }

    const setMode = (mode: ModeType) => {
        if (mode != props.mode) {
            root.classList.remove(props.mode);
            props.mode = mode;
            root.classList.add(props.mode);
        }
    }

    // Set event listener
    root.addEventListener('click', (e) => {
        if (!props.disabled) {
            props.checked = !props.checked;
            setChecked(props.checked);
            callbacks.onChange(props.checked);
        } else {
            e.preventDefault();
            console.info('Checkbox is disabled');
        }
    });

    // Set default value
    setChecked(props.checked);
    setEnabled(!props.disabled);
    // setLabel(props.label);

    return {
        element: root,
        setChecked: setChecked,
        setEnabled: setEnabled,
        setLabel: setLabel,
        setMode: setMode
    };
}
